<template>
    <div id="Container_TestResultPSSClinical">
      <MdTitleRegInfo
        v-bind:RegistrationInfo="PatientTitle" 
        v-bind:titlePrefix="$t('ENUM.CITEMS.TResults')" 
        v-bind:titleRef="'titleTResults'"
        v-bind:patientCode="this.$route.params.id">
      </MdTitleRegInfo>

  
      <iframe 
          allow-same-origin 
          allow-forms 
          id="iframe" 
          name="iframe" 
          class="fullheightiframe"
          frameborder="0"
          :src="iframeUrl"/>
      </div>
   
   
</template>
 
 <script>
 import EnumService from '@/services/enum.service';
 import DBFunctions from '@/common/DBFunctions.js'
 import Utils from "@/common/utils";
 import GlobalService from '@/services/global.service' 
 import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
  name: 'ClinicalTestResultPSS',
  props: {Origin:String},
  mixins: [DBFunctions, ShowMessage],


  data(){
    return{
      PatientTitle:{      
        programName:'',
        fullName:'',
        admitDate:'',
        dischargeDate:'',
        age:"",
        dob:'',
        activitytypename:'',
        startdatetime:'',
        ageFormatted:''
      },
      OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
      },
      currentAppointmentDB:{
          guid:'',
          activitytypecode:'',
          employee:{
          firstname:"",
              lastname:""
          }
      },
      iframeUrl: ""
    }
  },

  methods: {
    async GetPatientByCode(){
      var infoList = await this.getInfoTitle(this.$route.params.id);
      if(infoList.length > 0){
        this.PatientTitle.programName = '';
        this.PatientTitle.admitDate = '';
        this.PatientTitle.dischargeDate = '';

        const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

        if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
        if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
        if (age) this.PatientTitle.age = age;
        if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;               
      }
    },

     async CreatePSS(){
      try {
        const response = await GlobalService.getTestRSS(this.$route.params.id);
        
        if (response && response.data && response.data.labInterfaceURL) {
          console.log(response.data)
          this.iframeUrl = response.data.labInterfaceURL;
        } else {
          console.error('No se recibió labInterfaceURL en la respuesta');
          this.showMessage(
            this.$tc('Msg.Error'),
            this.$t('Msg.retrieveInfo'),
            "error"
          );
        }
        
      } catch (error) {
        if (!error.response) {                      
          this.showMessage(
            this.$tc('Msg.Error'),
            this.$t('Msg.retrieveInfo'),
            "error"
          );
        } else if(error.response.status === 400 ){
          this.showMessage(
            this.$tc('Msg.Error'),
            error.response.data,
            "error"
          );
        } else if(error.response.status === 500){
          this.showMessage(
            this.$tc('Msg.Error'),
            this.$t('Msg.ThereWereSomeError'),
            "error"
          );
        } else {
          this.showMessage(
            this.$tc('Msg.Error'),
            error.response.data,
            "error"
          );
        }
      }
    },


    async getCurrentAppointment() {
      this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
      this.PatientTitle.activitytypename  = this.currentAppointmentDB.activitytypename
      this.PatientTitle.startdatetime = `${Utils.formatterDateToString(this.currentAppointmentDB.transdate)} ${this.currentAppointmentDB.timein}`  
    }
  },
  async created() {
    this.GetPatientByCode();
    if (this.$route.name.includes('appointmentDB-epharmacy'))
      await this.getCurrentAppointment()
    this.CreatePSS();
  },
  async mounted(){

    this.OptionsRightMenu.visible = true;
    this.OptionsRightMenu.ItemsList = this.$route.name.includes('appointmentDB-') ? EnumService.AppointmentItems : EnumService.ClinicalItems
    this.$emit('getVisibleMenu', this.OptionsRightMenu);
    this.$emit('getBtnRightMenu', this.OptionsRightMenu);
  }
}
 </script>
 <style>
  .fullheightiframe{
    width: 100%;
    height: calc(100dvh - 115px);
  }
</style>